import { render, staticRenderFns } from "./NewsPageAgroSpectrum.vue?vue&type=template&id=41df6b58&scoped=true&"
import script from "./NewsPageAgroSpectrum.vue?vue&type=script&lang=js&"
export * from "./NewsPageAgroSpectrum.vue?vue&type=script&lang=js&"
import style0 from "./NewsPageAgroSpectrum.vue?vue&type=style&index=0&id=41df6b58&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41df6b58",
  null
  
)

export default component.exports